import {
  SHOW_PAGE_FAIL,
  SHOW_PAGE_REQUEST,
  SHOW_PAGE_SUCCESS,
} from "../../ActionType/BranchType/PageType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const showPositionAction = () => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_PAGE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("page/show", config);
    const { status, data } = response;
    // console.log(object)
    if (status == 200) {
      dispatch({
        type: SHOW_PAGE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: SHOW_PAGE_FAIL,
      payload: [],
    });
  }
};
